import { render, staticRenderFns } from "./FAQSection.vue?vue&type=template&id=1cf50290&scoped=true"
import script from "./FAQSection.vue?vue&type=script&lang=js"
export * from "./FAQSection.vue?vue&type=script&lang=js"
import style0 from "./FAQSection.vue?vue&type=style&index=0&id=1cf50290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf50290",
  null
  
)

export default component.exports